<template>
  <!-- <section class="app-main">
    <transition name="fade-transform" mode="out-in">
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section> -->
  <section class="app-main">
    <div class="app-main-title"><div class="app-main-title-line"></div>{{$route.meta.title}}</div>
    <transition name="fade-transform" mode="out-in">
      <div>
        <keep-alive>
          <router-view v-if="$route.meta.keepAlive" :key="key" />
        </keep-alive>
        <router-view v-if="!$route.meta.keepAlive" :key="key" />
      </div>
    </transition>
  </section>
</template>

<script>
export default {
  name: "AppMain",
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    key() {
      return this.$route.path;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/styles/variables.scss";

.app-main {
  /*107 = navbar 50 + topbar 57  */
  min-height: calc(100vh - 198px);
  width: 100%;
  position: relative;
  // overflow: hidden;
  // background-color: $newBg;
  background: #F0F2F5;
  padding: 16px;
  box-sizing: border-box;
}
.app-main-title{
  width: 100%;
height: 54px;
background: #FFFFFF;
border-radius: 6px;
display: flex;
align-items: center;
padding-left: 17px;
margin-bottom: 16px;
// line-height: 1;
font-weight: 1000;
color: #2D2D32;
font-size: 18px;
.app-main-title-line{
  width: 4px;
height: 14px;
background: #5A9804;
border-radius: 2px;
margin-right: 8px;
}
}
.fixed-header + .app-main {
  // padding-top: 84px;
}
.fixed-header{
  // padding-top: 64px;
}
</style>

<style lang="scss">
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    padding-right: 15px;
  }
}
</style>
